import { CourseInfo } from "@verity/components";
import { AssessmentInfo, VerityOptions } from "@verity/api-client/types";

class StorageEvent<T> {
	readonly #storageArea: Storage;
	readonly #key: string;
	readonly #listeners = new Set<(newVal: any) => void>();

	constructor(storageArea: Storage, key: string) {
		this.#storageArea = storageArea;
		this.#key = key;
		window.addEventListener("storage", this.#onStorageChanged.bind(this));
	}

	#onStorageChanged(ev: StorageEventInit) {
		if (ev.key === this.#key && this.#storageArea === ev.storageArea && ev.newValue) {
			for (const listener of this.#listeners) {
				listener(JSON.parse(ev.newValue));
			}
		}
	}

	add(eventHandler: (newVal: T) => void) {
		this.#listeners.add(eventHandler);
	}

	remove(eventHandler: (newVal: T) => void) {
		this.#listeners.delete(eventHandler);
	}
}

class StorageItem<T> {
	readonly #storageArea: Storage = sessionStorage;
	readonly #key: string;
	public readonly onChanged: StorageEvent<T>;

	constructor(key: string) {
		this.#key = key;
		this.#storageArea = sessionStorage;
		this.onChanged = new StorageEvent(this.#storageArea, this.#key);
	}

	/**
	 *
	 * @returns stored item if exists or null if does not exist
	 */
	get(): T | null {
		const serialized = this.#storageArea.getItem(this.#key);
		return !serialized || JSON.parse(serialized);
	}

	/**
	 *
	 * @param item Must be JSON serializable with JSON.stringify
	 */
	set(item: T): void {
		this.#storageArea.setItem(this.#key, JSON.stringify(item));
	}
}

export namespace storage {
	export const VeritySettings = new StorageItem<Partial<VerityOptions>>("veritySettings");
	export const VerityQuizInfo = new StorageItem<AssessmentInfo>("verityQuizInfo");
	export const BlackboardCourseInfo = new StorageItem<CourseInfo>("blackboardCourseInfo");
}
